import React from 'react';
import { Flex, BreadcrumbNav, Icon, icons } from '@tapresearch/ui/components';
import { useBreadcrumb } from '../../hook/useBreadcrumb';

export const BreadcrumbContainer = () => {
  const { breadcrumb, altContent } = useBreadcrumb();
  const { center, centerProps, right, rightProps } = altContent || {};

  if (!breadcrumb.length && !altContent) return null;

  return (
    <Flex className="breadcrumb" {...Styles.BreadcrumbContainer}>
      <Flex {...Styles.FlexColumn}>
        <BreadcrumbNav
          color="gray.800"
          items={breadcrumb}
          separator={
            <Icon boxSize={7} icon={icons.fi.ChevronRight} color="blue.500" />
          }
        />
      </Flex>
      <Flex {...Styles.FlexColumn} {...centerProps}>
        {center}
      </Flex>
      <Flex
        {...Styles.FlexColumn}
        {...{
          justify: 'flex-end',
        }}
        {...rightProps}
      >
        {right}
      </Flex>
    </Flex>
  );
};

const Styles = {
  BreadcrumbContainer: {
    width: 'full',
    bg: 'white',
    maxW: 'none',
    px: 5,
    h: '100%',
    align: 'center',
    justify: 'space-between',
    sx: {
      ol: {
        display: 'flex',
        alignItems: 'stretch',
        h: '45px',
      },
      li: {
        alignItems: 'stretch',
        '> span:not(.chakra-text)': {
          display: 'flex',
          alignItems: 'center',
          mx: 1,
        },
      },
      a: {
        display: 'flex',
        alignItems: 'center',
        h: '100%',
        rounded: 'lg',
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
  FlexColumn: {
    flex: 1,
    align: 'center',
    h: '100%',
  },
};
